// extracted by mini-css-extract-plugin
export default {"container":"Y9fpL","link":"WHwjV","term":"E+vHe"};